<template>
  <div class="appointmentcontainer">
<!--    <div class="banner-1">-->
<!--      <img src="../../assets/common/images/banner_szzy.jpg" alt="">-->
<!--    </div>-->
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">场馆预订</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel2 clearfix p30">
        <el-button v-if="isEnroll" class="ljyd" type="primary" @click="enrollfun">立即预定</el-button>
        <h2 class="title ptb20 style1">{{detailparams.name}}</h2>
        <ul class="ul1 clearfix">
          <li  v-if="detailparams.phone !== ''"><i class="icon icon1"></i>电话：{{detailparams.phone}}</li>
          <li  v-if="detailparams.equipments !== ''"><i class="icon icon2"></i>设备：{{detailparams.equipments}}</li>
          <li v-if="detailparams.size !== ''"><i class="icon icon3"></i>面积：{{detailparams.size}}</li>
          <li v-if="detailparams.address !== ''"><i class="icon icon4"></i>地址：{{detailparams.address}}</li>
          <li v-if="detailparams.sectionDataList && detailparams.sectionDataList.length!== 0">
            <i class="icon icon5"></i>容纳：{{detailparams.sectionDataList.length===0 ? '' : detailparams.sectionDataList[0].pnum}}</li>
          <li v-if="detailparams.cost !== ''"><i class="icon icon6"></i>费用：{{detailparams.cost}}</li>
          <li v-if="detailparams.remarks !== ''"><i class="icon icon7"></i>备注：{{detailparams.remarks}}</li>
        </ul>
        <div class="imgbanner">
          <div class="gallerythumbsbox">
            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
              <!-- <div class="swiper-wrapper"> -->
                <swiper-slide class="swiper-slide" v-for="(item,index) in imageList"
                 :key="index">
                  <img class="imgtop" :src="getImage(item)" />
                </swiper-slide>

              <!-- </div> -->
            </swiper>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </div>

          <!-- swiper1 -->
          <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <!-- <div class="swiper-wrapper"> -->
               <swiper-slide class="swiper-slide" v-for="(item,index) in imageList"
                 :key="index+'a'">
                  <img class="imgtop" :src="getImage(item)"  />
                </swiper-slide>

            <!-- </div> -->
          </swiper>

        </div>
        <div class="contentbox" v-html="detailparams.content">

        </div>
  <comment v-if="detailparams" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>

        <right-sidebar @pvcount="pvcount" :comment-count="commentTotal" :comment-gotop="commentOffsettop" :comment-show="isCommentshow" ref="rightSidebar"
        :title="detailparams.name"
      :image="getImage(detailparams.image)"
      :url="this.$route.fullPath"
        ></right-sidebar>
        <go-top></go-top>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import {getvenueDetail} from '@/api/venue/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'venuedetail',
  components: {
    Comment,
    RightSidebar,
    goTop,
    crumbs,
    swiper,
    swiperSlide
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      id: 0,
      menuId: '',
      detailparams: {},
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      swiperOptionTop: {
        grabCursor: true,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10
      },
      swiperOptionThumbs: {
        // grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状
        // centeredSlides: true,
        // // initialSlide: 1,
        // slidesPerView: 'auto', // 同时显示的数量
        // touchRatio: 0.2,
        // slideToClickedSlide: true,
        // spaceBetween: 20,
        // loop: true,

        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      imageList: [],
      List: [],
      isEnroll: true
    }
  },
  created () {
    this.id = this.$route.query.id
    this.menuId = this.$route.query.columnId
    this.getDetail()
  },
  updated () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$el.swiper
      const swiperThumbs = this.$refs.swiperThumbs.$el.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotName === 'venueEnrollbtn') {
          if (parseInt(item.slotCode) === 1) {
            this.isEnroll = false
          } else {
            this.isEnroll = true
          }
        }
      })
    },
    getDetail () {
      getvenueDetail(this.id).then(res => {
        console.log(res)
        this.detailparams = res.data.data
        this.imageList = res.data.data.images.split('|')
      })
    },
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    enrollfun () {
      if (this.$cookie.get('wlyuserid') === undefined || this.$cookie.get('wlyuserid') === null) {
        this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
      } else {
        this.$router.push({
          path: '/venueenroll',
          query: {
            id: this.id,
            menuId: this.menuId
          }
        })
      }
    },
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .appointmentcontainer{
    padding: 0 0 100px;
  }
 .gallery-thumbs .swiper-slide{
   width: 200px;
   height: 100px;
 }
  .gallery-thumbs .swiper-slide.swiper-slide-active{
    border: 2px #00c868 solid;
  }

  .swiper-slide{
    img{
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/venue/detail.vue